module.exports = __webpack_public_path__ + "static/img/wl1400bb.edc4134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wl1400bb.jpg
// module id = Za7v
// module chunks = 0